<template>
  <div>
    <el-page-header @back="goBack">
      <template #content>
        <span class="text-large font-600 mr-3"> OnePage </span>
      </template>
      <template #extra>
        <div class="button-container">
          <el-button
            v-show="
              userRoles.includes(Roles.Manager) ||
              userRoles.includes(Roles.Admin)
            "
            :loading="loadingEliminarProy"
            class="buttonIdilia"
            round
            @click="eliminarProyecto"
          >
            Eliminar proyecto
          </el-button>
          <el-button
            v-if="!proyectoSeleccionado.Iniciado"
            :loading="loadingIniciarProy"
            class="buttonIdilia"
            round
            @click="iniciarProyecto"
          >
            Iniciar proyecto
          </el-button>
          <el-button class="buttonIdilia" round @click="abrirProyecto">
            Ver detalle
          </el-button>
          <el-button round class="buttonIdilia" @click="verTareas"
            >Ver tareas</el-button
          >
        </div>
      </template>
    </el-page-header>
    <el-container>
      <el-main>
        <el-row :gutter="30" style="margin-bottom: 0px">
          <el-col :span="4">
            <div class="image__preview demo-image__error">
              <el-image
                style="max-width: 200px; height: 100px; margin-left: 40px"
                :src="proyectoSeleccionado.Foto"
                :preview-src-list="[proyectoSeleccionado.Foto]"
                :initial-index="0"
                fit="fill"
              >
                <template #error>
                  <div class="image-slot">
                    <el-icon><icon-picture /></el-icon>
                  </div>
                </template>
              </el-image>
            </div>
          </el-col>
          <el-col :span="5">
            <el-row :gutter="30">
              <el-col>{{ proyectoSeleccionado.Descripcion }}</el-col>
            </el-row>
            <el-row>
              <el-col>
                Líderes:
                <div
                  v-if="
                    !proyectoSeleccionado.Lideres ||
                    proyectoSeleccionado.Lideres.trim().length === 0
                  "
                >
                  No se han seleccionado líderes.
                </div>
                <mgt-person
                  v-for="p in proyectoSeleccionado.Lideres?.split(';')"
                  v-else
                  :key="p"
                  :user-id="p"
                  view="oneline"
                  person-card="hover"
                  fetch-image
                />
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="15">
            <el-row>
              <el-col :span="24">
                <el-row>
                  <el-col :span="4">
                    <el-statistic
                      title="Tiempo transcurrido"
                      :value="DaysSince(proyectoSeleccionado.Creado) + ' días'"
                    />
                  </el-col>
                  <el-col :span="1">
                    <el-divider direction="vertical" class="divider-large" />
                  </el-col>
                  <el-col :span="4">
                    <el-statistic
                      title="Tareas pendientes"
                      :value="TareasStore.GetNumberTareasPendientes.length"
                    />
                  </el-col>
                  <el-col :span="1">
                    <el-divider direction="vertical" class="divider-large" />
                  </el-col>
                  <el-col :span="4">
                    <el-statistic
                      title="Tareas fuera de plazo"
                      :value="TareasStore.GetNumberTareasDelayed.length"
                    />
                  </el-col>
                  <el-col :span="1">
                    <el-divider direction="vertical" class="divider-large" />
                  </el-col>
                  <el-col :span="4">
                    <el-statistic
                      title="Vencen los próximos 7 días"
                      :value="TareasStore.GetNumberTareasProximasVencer.length"
                    />
                  </el-col>
                  <el-col :span="1">
                    <el-divider direction="vertical" class="divider-large" />
                  </el-col>

                  <el-col :span="4">
                    <el-statistic
                      title="Deadline Liberación PA"
                      :value="dateToString(proyectoSeleccionado.FechaServicio)"
                    />
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="30">
          <el-col :span="8">
            <span style="font-size: larger; color: #c2120e"> Referencias </span>
            <el-table
              class="main-table"
              ref="tableReferenciasPA"
              :data="productosAcabados"
              style="width: 100%; box-sizing: border-box; margin-top: 5px"
              max-height="600"
              empty-text="No se han seleccionado referencias"
              stripe
              table-layout="fixed"
              @row-click="openPanelMateriales"
            >
              <el-table-column width="20" show-overflow-tooltip>
                <template #default="scope">
                  <span v-if="scope.row.BloquearMateriales">
                    <el-tooltip
                      placement="top-start"
                      content="Materiales bloqueados"
                    >
                      <el-icon
                        style="
                          font-size: 16px;
                          color: #e00d0d;
                          margin-right: 10px;
                        "
                      >
                        <Lock />
                      </el-icon>
                    </el-tooltip>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Código" width="90" property="Codigo" />
              <el-table-column
                property="Descripcion"
                label="Descripcion"
                show-overflow-tooltip
              />
              <el-table-column width="40" show-overflow-tooltip>
                <template #default="scope">
                  <span
                    v-if="scope.row.EditarCodigo"
                    class="dotWithOutTooltip"
                    :style="'background-color: #E00D0D !important;text-align: center;margin-right: 10px; color: transparent !important;'"
                  >
                    Nueva referencia
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <el-drawer
              v-model="panelVisible"
              :title="referenciaSelected?.Descripcion"
              direction="rtl"
              size="50%"
            >
              <div class="image__preview demo-image__error">
                <el-image
                  style="max-width: 200px; height: 100px; margin-left: 40px"
                  :src="referenciaSelected?.Foto"
                  fit="fill"
                >
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
              </div>
              <el-descriptions
                title="Datos de la referencia"
                border
                :column="1"
              >
                <el-descriptions-item label="Marca">
                  {{ referenciaSelected?.Marca }}
                </el-descriptions-item>
                <el-descriptions-item label="Familia">
                  {{ familia?.PROD_HIER + " " + familia?.TEXT }}
                </el-descriptions-item>
                <el-descriptions-item label="Subfamilia">
                  {{ subfamilia?.PROD_HIER + " " + subfamilia?.TEXT }}
                </el-descriptions-item>
                <el-descriptions-item label="Formato">
                  {{ formato?.PROD_HIER + " " + formato?.TEXT }}
                </el-descriptions-item>
              </el-descriptions>
              <span class="title">Materiales</span>
              <el-table :data="Materiales">
                <el-table-column property="Codigo" label="Código" width="150" />
                <el-table-column property="Descripcion" label="Descripcion" />
                <el-table-column width="50" show-overflow-tooltip>
                  <template #default="scope">
                    <span
                      v-if="scope.row.CambioDiseno"
                      class="dotWithOutTooltip"
                      :style="
                        'background-color: #E00D0D' +
                        ' !important;text-align: center;margin-right: 10px;' +
                        'color: transparent !important;'
                      "
                      >Cambio diseño</span
                    >
                  </template>
                </el-table-column>
                <el-table-column property="Tipo" width="100" label="Tipo" />
                <el-table-column
                  property="Cantidad"
                  width="100"
                  label="Cantidad"
                />
                <el-table-column property="UM" width="100" label="UM" />
              </el-table>
            </el-drawer>
          </el-col>
          <el-col v-loading="loading" :span="16" style="margin-top: -30px">
            <div style="display: flex; justify-content: flex-end">
              <el-button
                :icon="Refresh"
                circle
                class="icon-idilia"
                style="margin: 10px; float: right"
                @click="RefreshTareas"
              />
            </div>
            <GanttTasks class="left-container" />
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script setup lang="ts">
import {
  ref,
  reactive,
  computed,
  defineAsyncComponent,
  onBeforeUnmount,
} from "vue";
import { Picture as IconPicture, Refresh } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";
import { useProyectosStore, Proyecto } from "@/store/ProyectosStore";
import { registerMgtPersonComponent } from "@microsoft/mgt";
import {
  ProductoAcabado,
  useProductosAcabadoStore,
} from "@/store/ProductosAcabadoStore";
import { useCommonStore, Roles } from "@/store/CommonStore";
import { Material, useMaterialesStore } from "@/store/MaterialesStore";
import { EstadosTareas, useTareasStore } from "@/store/TareasStore";
import { onMounted } from "vue";
import Helper from "@/common/Helper";
import { ElMessageBox, ElNotification, UploadUserFile } from "element-plus";
import { FaseEstado, useFasesStore } from "@/store/FaseStore";
import { useUserStore } from "@/store/UserStore";
const FaseStore = useFasesStore();
const { DaysSince, dateToString, keyExistsEquipos } = Helper();
const GanttTasks = defineAsyncComponent(
  () => import("../components/GanttTasks.vue")
);
registerMgtPersonComponent();
const router = useRouter();
const route = useRoute();
const TareasStore = useTareasStore();
const ProyectosStore = useProyectosStore();
const ProductosAcabadoStore = useProductosAcabadoStore();
const MaterialesStore = useMaterialesStore();
const CommonStore = useCommonStore();
const UserStore = useUserStore();
// const proyectoFoto = ref<UploadUserFile>({ name: '', url: ''})
const referenciaSelected = ref<ProductoAcabado>();
const Materiales = ref<Material[]>();
const panelVisible = ref(false);
const proyectoEmpty: Proyecto = {
  IdProyecto: 0,
  Descripcion: "",
  FechaServicio: "",
  Lideres: "",
  Foto: "",
  LoteMixto: false,
  LoteMixtoComponentes: "",
  EstimacionComercial: 0,
  Clientes: "",
  Fase: "",
  Creado: "",
  CreadoPor: "",
  Equipo: "",
  Completado: false,
  Duracion: 0,
  Iniciado: false,
  KeyEquipo: "",
  TareasProximasVencer: 0,
  TareasVencidas: 0,
  Unidad: "",
};
const userRoles = computed(() => {
  return UserStore.userRoles;
});
const loadingIniciarProy = ref(false);
const loadingEliminarProy = ref(false)
const proyectoSeleccionado: Proyecto = reactive<Proyecto>(proyectoEmpty);
const goBack = () => {
  router.push({ name: "Dashboard" });
};
// const proySel = ProyectosStore.Proyectos?.find((data:Proyecto) => data.IdProyecto.toString() === route.params.Pid)

const productosAcabados = computed(() => {
  return ProductosAcabadoStore.ProductosAcabados;
});
const loading = computed(() => {
  return !TareasStore.TareasLoaded;
});

const openPanelMateriales = async (val: ProductoAcabado | undefined) => {
  if (val) {
    await MaterialesStore.GetMaterialesByProductoAcabado(val.IdPA);
  }
  referenciaSelected.value = val;
  panelVisible.value = true;
  Materiales.value = MaterialesStore.MaterialesPA;
};
const eliminarProyecto = async () => {
  ElMessageBox.confirm(
    "¿Seguro que quieres eliminar el proyecto? Esta acción no se podrá revertir.",
    "Eliminar proyecto",
    {
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      type: "warning",
    }
  )
    .then(async () => {
      // Unicamente no se puede eliminar si alguna PA es nueva referencia y tiene codigo informado.
      loadingEliminarProy.value = true
      let permitirEliminar = true;
      let productosAcabadosInc = "";
      productosAcabados.value?.forEach((pa) => {
        if (pa.EditarCodigo && pa.Codigo) {
          permitirEliminar = false;
          productosAcabadosInc += `<li>${pa.Codigo} - ${pa.Descripcion}</li>`;
        }
      });
      if (permitirEliminar) {
        await ProyectosStore.DeleteProyecto(proyectoSeleccionado.IdProyecto);
        loadingEliminarProy.value=false
        ElMessageBox.alert('El proyecto se ha eliminado correctamente', 'Proyecto eliminado', {
    // if you want to disable its autofocus
    // autofocus: false,
    confirmButtonText: 'Aceptar',
    callback: () => {
      goBack()
    }
  })
      } else {
        ElMessageBox.alert(
          "<p>No se puede eliminar el proyecto por que las siguientes PAs tiene nueva referencia ya informada. <br>" +
            "<ul>" +
            productosAcabadosInc +
            "</ul>",
          "Error al eliminar el proyecto",
          {
            dangerouslyUseHTMLString: true,
          }
        );
      }
    })
    .catch(() => {
      console.log("No se elimina el proyecto");
    });
};
const iniciarProyecto = async () => {
  loadingIniciarProy.value = true;
  if (
    proyectoSeleccionado.KeyEquipo &&
    keyExistsEquipos(proyectoSeleccionado.KeyEquipo)
  ) {
    await TareasStore.UpdateProjectTasks(proyectoSeleccionado, null, null);
    if (productosAcabados.value && productosAcabados.value.length > 0) {
      for (let i = 0; i < productosAcabados.value.length; i++) {
        const pa = productosAcabados.value[i];
        await TareasStore.UpdateProjectTasks(proyectoSeleccionado, pa, null);
        await MaterialesStore.GetMaterialesByProductoAcabado(pa.IdPA);
        if (
          MaterialesStore.MaterialesPA &&
          MaterialesStore.MaterialesPA.length > 0
        ) {
          for (let m = 0; m < MaterialesStore.MaterialesPA.length; m++) {
            const material = MaterialesStore.MaterialesPA[m];
            if (material.CambioDiseno) {
              await TareasStore.UpdateProjectTasks(
                proyectoSeleccionado,
                pa,
                material
              );
            }
          }
        }
      }
    }
    proyectoSeleccionado.Iniciado = true;
    const faseEstados: FaseEstado[] = [];
    if (FaseStore.Fases) {
      FaseStore.Fases.forEach((fase) => {
        faseEstados.push({ Fase: fase.Id, Estado: EstadosTareas.NotStarted });
      });

      // --

      // Fases por cada PA
      let pasFases: { Descripcion: string; Fases: FaseEstado[] }[] = [];
      if (productosAcabados.value && productosAcabados.value.length > 0) {
        pasFases = productosAcabados.value.map((pa) => {
          let fasesPA: { Fase: number; Estado: EstadosTareas }[] = [];
          if (FaseStore.Fases) {
            fasesPA = FaseStore.Fases.map((fase) => ({
              Fase: fase.Id,
              Estado: EstadosTareas.NotStarted,
            }));
          }
          return { Descripcion: pa.Descripcion, Fases: fasesPA };
        });
      }
      // --

      // JSON final
      const jsonFases = { Proyecto: faseEstados, PAs: pasFases };

      proyectoSeleccionado.Fase = JSON.stringify(jsonFases);
    }
    const proyectoFoto: UploadUserFile = {
      name: "",
      url: proyectoSeleccionado.Foto,
    };
    ProyectosStore.UpdateProyecto(proyectoSeleccionado, proyectoFoto);
    ElNotification({
      title: "Proyecto iniciado",
      message:
        "El proyecto se ha iniciado correctamente. Es posible que necesite actualizar para ver todas las tareas correctamente.",
      type: "success",
      offset: 100,
    });
  } else {
    ElMessageBox.alert(
      "No se ha encontrado ningún equipo para este proyecto. Es posible que el equipo ya no exista o no tenga tareas configuradas. Proyecto no iniciado.",
      "Atención",
      { confirmButtonText: "OK" }
    );
  }

  loadingIniciarProy.value = false;
};
const abrirProyecto = () => {
  MaterialesStore.EmptyMaterialesPA();
  router.push({ name: "Wizard", params: { Pid: route.params.Pid } });
};
const verTareas = () => {
  router.push({ name: "GestionTareas", params: { Pid: route.params.Pid } });
};

const familia = computed(() => {
  return CommonStore.Familias?.filter(
    (item) => item.PROD_HIER === referenciaSelected.value?.Familia
  )[0];
});

const subfamilia = computed(() => {
  return CommonStore.Subfamilias?.filter(
    (item) => item.PROD_HIER === referenciaSelected.value?.Subfamilia
  )[0];
});

const formato = computed(() => {
  return CommonStore.Formatos?.filter(
    (item) => item.PROD_HIER === referenciaSelected.value?.FormatoComercial
  )[0];
});
const RefreshTareas = async () => {
  TareasStore.EmptyTareas();
  await ProductosAcabadoStore.GetProductoAcabadoById(Number(route.params.Pid));
  await TareasStore.GetByIdProyectoGantt(Number(route.params.Pid));
  await TareasStore.GetAllTareasPendientes(Number(route.params.Pid));
};
onMounted(async () => {
  TareasStore.EmptyTareas();
  MaterialesStore.EmptyMaterialesPA();
  await ProyectosStore.GetProyectoById(Number(route.params.Pid));
  await ProductosAcabadoStore.GetProductoAcabadoById(Number(route.params.Pid));
  Object.assign(
    proyectoSeleccionado,
    ProyectosStore.ProyectoSelected || proyectoEmpty
  );
  await TareasStore.GetByIdProyectoGantt(Number(route.params.Pid));
  await TareasStore.GetAllTareasPendientes(Number(route.params.Pid));
  if (!proyectoSeleccionado.Iniciado)
    await TareasStore.GetTareasConfiguracion();
});
onBeforeUnmount(async () => {
  TareasStore.EmptyTareas();
});
</script>
<style scoped>
/* html, body {
    height: 100%;
    margin: 0;
    padding: 0;
  } */
/* .container {
    height: 100vh;
    width: 100%;
  } */

.left-container {
  overflow: hidden;
  position: relative;
  height: 65vh;
}
</style>
